<template>
    <div>
        <datatable-filter
            v-show="datatable.filterStatus"
            @filter="getRows"
            @filterClear="filterClear"
        >
        <b-row>
            <b-col sm="6" md="3">
                <b-form-group :label="$t('national_id')">
                    <b-form-input type="text" v-model="datatable.queryParams.filter.national_id"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="6" md="3">
                <b-form-group :label="$t('student_number')">
                    <b-form-input
                        v-model="datatable.queryParams.filter.student_number">
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="6" md="3">
                <b-form-group :label="$t('name')">
                    <b-form-input type="text" v-model="datatable.queryParams.filter.name"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col sm="6" md="3">
                <b-form-group :label="$t('surname')">
                    <b-form-input type="text" v-model="datatable.queryParams.filter.surname"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col sm="6" md="3">
                <b-form-group :label="$t('faculty')">
                    <faculty-selectbox v-model="datatable.queryParams.filter.faculty_code"/>
                </b-form-group>
            </b-col>
            <b-col sm="6" md="3">
                <b-form-group :label="$t('department')">
                    <department-selectbox
                        :faculty_code="datatable.queryParams.filter.faculty_code"
                        v-model="datatable.queryParams.filter.department_code">
                    </department-selectbox>
                </b-form-group>
            </b-col>
            <b-col sm="6" md="3">
                <b-form-group :label="$t('program')">
                    <ProgramSelectbox v-model="datatable.queryParams.filter.program_code" :faculty_code="datatable.queryParams.filter.faculty_code"/>
                </b-form-group>
            </b-col>
        </b-row>
    </datatable-filter>
        <datatable :isLoading.sync="datatable.isLoading"
                   :columns="datatable.columns"
                   :rows="datatable.rows"
                   :total="datatable.total"
                   :queryParams="datatable.queryParams"
                   @on-page-change="onPageChange"
                   @on-sort-change="onSortChange"
                   @on-per-page-change="onPerPageChange"
                   v-show="datatable.showTable"
        >
        </datatable>

        <CommonModal ref="updateUserModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
            <template v-slot:CommonModalTitle>
                {{ $t('new').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <StudentUpdateForm v-if="formProcess==='updateUserModal'" @closeUpdateInfirmaryModal="closeUpdateInfirmaryModal" :formId="formId"/>
            </template>
        </CommonModal>
    </div>
</template>
<script>
import qs from "qs";
import InfirmaryServices from "@/services/InfirmaryServices";
import StudentUpdateForm from "@/modules/infirmary/pages/tabs/students/StudentUpdateForm.vue";

export default {
    name: "Student",
    components: {StudentUpdateForm},
    data(){
        return {
            formProcess:null,
            formId:null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('edit_patient_information'),
                                class: 'ri-edit-box-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "infirmaryuser_updateuserdetail",
                                callback: (row) => {
                                    this.updateFormShow(row.user_id)
                                }
                            },
                            {
                                text: this.$t('create_new_examination'),
                                class: 'ri-add-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "infirmaryrecord_createinfirmaryrecord",
                                disabled:(row)=>{
                                    return  row.id===null
                                },
                                callback: (row) => {
                                    this.$emit('createNewExamination',row.id)
                                },
                            },
                            {
                                text: this.$t('patient_history'),
                                class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "infirmaryrecord_indexinfirmaryrecord",
                                disabled:(row)=>{
                                    return  row.id===null
                                },
                                callback: (row) => {
                                    this.$emit('openPatientHistoryModal',row.id)
                                },
                            }
                        ]
                    },
                    {
                        label: this.toUpperCase('id'),
                        field: 'id',
                        hidden: true,
                    },
                    {
                        label: this.toUpperCase('national_id'),
                        field: 'national_id',
                        hidden: false,
                        sortable: false,
                    },
                    {
                        label: this.toUpperCase('student_number'),
                        field: 'student_number',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('name'),
                        field: 'name',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('surname'),
                        field: 'surname',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('faculty'),
                        field: 'faculty',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('department'),
                        field: 'department',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('program'),
                        field: 'program',
                        hidden: false,
                        sortable: false
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: 20
                }
            },
        }
    },
    methods:{
        formClear() {
            this.formProcess = null
        },
        filterSet() {
            this.datatable.queryParams.filter = {
                national_id: null,
                name: null,
                surname: null,
                gender: null,
            }
        },
        filterClear() {
            this.filterSet();
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return InfirmaryServices.studentGetAll(config).then(response => {
                this.datatable.rows = response.data.data
                this.datatable.total = response.data.pagination.total
            })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        updateFormShow(id) {
            this.formId = id
            this.formProcess = 'updateUserModal'
            this.$refs.updateUserModal.$refs.commonModal.show()
        },
        closeUpdateInfirmaryModal(){
            this.formId=null
            this.formProcess=null
            this.$refs.updateUserModal.$refs.commonModal.hide()
        }

    }
}
</script>

<style scoped>

</style>
